/**
 * 홍보툰(comic) 스토리: 백엔드 stories.content 저장 형식과 파싱.
 * content 예: {"version":1,"images":["https://...supabase.co/...","..."]}
 */

import { resolveMediaUrl } from '../api/api';

/** content → 이미지 URL 배열 (Supabase public URL 또는 상대경로) */
export function parseComicImageList(content) {
  if (!content || !String(content).trim()) return [];
  const s = String(content).trim();
  try {
    const parsed = JSON.parse(s);
    if (parsed && Array.isArray(parsed.images)) {
      return parsed.images.filter(Boolean);
    }
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
  } catch (e) {
    /* 레거시: 한 줄에 하나의 URL */
  }
  return s
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
}

/** 이미지 URL 배열 → DB 저장용 JSON 문자열 */
export function serializeComicContent(imagePaths) {
  return JSON.stringify({ version: 1, images: imagePaths.filter(Boolean) });
}

/** API row → StoriesPage용 comic 카드 */
export function storyToComicCard(story) {
  const paths = parseComicImageList(story.content);
  const images = paths.map((p) => resolveMediaUrl(p));
  const thumbnail = story.image
    ? resolveMediaUrl(story.image)
    : images[0] || '';
  return {
    id: story.id,
    title: story.title,
    description: story.summary,
    thumbnail,
    images: images.length ? images : thumbnail ? [thumbnail] : [],
  };
}
